import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import jobs from '../../data/jobs';
import Title from '../Title';
import Button from '../Button';

const JobDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  const job = jobs.find((j) => j.slug === slug);
  const jobData = t(`careers.jobs`, { returnObjects: true });
  const jobEntry = Object.values(jobData).find((j) => j.slug === slug);
  const jobButtonText = t('careers.job_button');

  if (!job || !jobEntry) {
    return <div>Job not found</div>;
  }

  const {
    title,
    location,
    intro,
    position,
    role,
    experience,
    qualifications,
    additional_info,
  } = jobEntry;

  const renderDetails = (label, content) => (
    <p className='flex flex-col md:flex-row gap-2'>
      <span className='text-lg lg:text-xl font-medium text-primary-red'>
        {label}:
      </span>
      <span>{content}</span>
    </p>
  );

  const renderList = (label, items) => (
    <>
      <p className='text-lg lg:text-xl font-medium text-primary-red'>
        {label}:
      </p>
      <ul className='list-disc pl-6'>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </>
  );

  return (
    <div className='flex flex-col items-center justify-center p-6 lg:p-12 gap-6 lg:gap-12 text-primary-blue max-w-[1600px] mx-auto w-full'>
      <Title>{title}</Title>
      <div className='flex flex-col w-full gap-6 text-justify text-lg lg:text-xl font-light leading-8'>
        {renderDetails(t(location.label), location.value)}
        <p>{intro}</p>
        {renderDetails(t(position.label), position.value)}
        {renderList(t(role.label), role.value)}
        {renderList(t(experience.label), experience.value)}
        {renderList(t(qualifications.label), qualifications.value)}
        <p>{additional_info}</p>
        <a
          href='mailto:careers@quantessence.com'
          target='_blank'
          rel='noreferrer'
        >
          <Button>{jobButtonText}</Button>
        </a>
        <p className='text-base text-primary-blue'>
          <Trans i18nKey='careers.employee_notice'>
            ...
            <a
              href='/employeepolicy'
              rel='noreferrer'
              target='_blank'
              className='text-primary-red'
            >
              Employee Privacy Notice
            </a>
            .
          </Trans>
        </p>
      </div>
    </div>
  );
};

export default JobDetail;
